import { useEffect } from "react";
import { useT } from "../i18n/LanguageContext";
import AvailabilityBar from "../components/site/AvailabilityBar";
import Header from "../components/site/Header";
import Hero from "../components/site/Hero";
import EmBreve from "../components/site/EmBreve";
import Anfitrioes from "../components/site/Anfitrioes";
import BannerPreco from "../components/site/BannerPreco";
import Comodidades from "../components/site/Comodidades";
import Galeria from "../components/site/Galeria";
import Distancias from "../components/site/Distancias";
import Vizinhanca from "../components/site/Vizinhanca";
import Restaurantes from "../components/site/Restaurantes";
import SegredosSul from "../components/site/SegredosSul";
import Reserva from "../components/site/Reserva";
import Reviews from "../components/site/Reviews";
import Footer from "../components/site/Footer";
import WhatsAppFab from "../components/site/WhatsAppFab";

export default function MexiHome() {
  const { lang } = useT();
  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [lang]);

  return (
    <main data-testid="mexihome-page" className="overflow-x-hidden">
      <AvailabilityBar />
      <Header />
      <Hero />
      <EmBreve />
      <Anfitrioes />
      <BannerPreco />
      <Comodidades />
      <Galeria />
      <Distancias />
      <Vizinhanca />
      <Restaurantes />
      <SegredosSul />
      <Reserva />
      <Reviews />
      <Footer />
      <WhatsAppFab />
    </main>
  );
}
